import { Weld } from '@bechtel/types';

export enum WeldDetailItemTabType {
  SUMMARY = 'SUMMARY',
  DETAILS = 'DETAILS',
  PHOTOS = 'PHOTOS',
  DOCUMENTS = 'DOCUMENTS',
}

export enum CommoditySectionDetail {
  CommoditySectionTitle = 'packaging',
  CommoditySectionName = 'test package number',
}

export interface WeldDetailItemTab {
  label: string;
  value: WeldDetailItemTabType;
}

export interface WeldDetailItemProps {
  weld: Weld;
  loading: boolean;
  fetchMore: (e) => void;
}
